import { ValidateFields } from "../../../modules/form/ValidateFields";
import { Typology } from "../../../modules/typology/Typology";
import { FormService } from "../../services/FormService";
import { loadDataAVI } from "../functions/loadDataAVI";
import { textFunctions } from "../functions/textFunctions";
import { setUserData } from "../interfaces/UserInterface";
import { getDeviceType } from "../variables/globalVariables";
import { CalculatorForm } from "./CalculatorForm";
import { sendFormPreregistro } from "./PreregistroForm";
/**
 * @description Class responsible for handling the form submission.
 */
class ContactForm {
    // Constructor where the form state is initialized and methods are bound to the correct context
    constructor(formState) {
        this.formState = formState;
        this.formName = '';
        this.contact = 2;
        this.ID = 0;
        this.typologyPrice = '';
        this.contextComponent = '';
        this.openCalculator = '';
        this.redirectTo = '';
        this.UrlApi = '/api/ev-lead';
        this.typologyType = '';
        this.typologyName = '';
        this.typologyIncome = '';
        this.typologyProperty = '';
        this.countryCode = '';
        this.phone = '';
        // Bind methods to the correct context (this)
        this.submitForm = this.submitForm.bind(this);
        this.setUserForm = this.setUserForm.bind(this);
        this.setContactForm = this.setContactForm.bind(this);
    }
    /**
     * Method responsible for submitting the form with the gathered information.
     * @param contactModal - Identifier for the contact modal being used.
     */
    submitForm() {
        var _a, _b, _c, _d, _e, _f;
        // Select the form using the provided ID
        const attributes = [
            'typology-id', 'typology-price', 'typology-type', 'typology-name',
            'typology-income', 'typology-property', 'product-ofert', 'form-name',
            'builder-number', 'builder-name', 'fair', 'fairBuilder', 'fairWhiteBrand'
        ];
        const nameConvertedField = (str) => {
            return str.replace(/-./g, match => match.charAt(1).toUpperCase());
        };
        attributes.forEach(attribute => {
            var _a;
            let nameStateField = nameConvertedField(attribute);
            let value = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.getAttribute(attribute);
            if (value) {
                if (attribute.includes('fair') && value == '1') {
                    nameStateField = 'productOfert';
                    if (attribute == 'fairWhiteBrand') {
                        value = '8';
                    }
                    else if (attribute == 'fairBuilder') {
                        value = '7';
                    }
                    else if (attribute == 'fair') {
                        value = '3';
                    }
                }
                this.formState.manageState(nameStateField, value);
            }
        });
        let formNameValue = this.formState.manageState('formName');
        let nid = (_a = document.querySelector(formNameValue)) === null || _a === void 0 ? void 0 : _a.getAttribute('value');
        this.ID = this.formState.manageState('typologyId');
        if (nid && !this.ID) {
            this.ID = Number(nid);
        }
        this.typologyPrice = this.formState.manageState('typologyPrice');
        this.typologyType = this.formState.manageState('typologyType');
        this.typologyName = this.formState.manageState('typologyName');
        this.typologyIncome = this.formState.manageState('typologyIncome');
        this.typologyProperty = this.formState.manageState('typologyProperty');
        this.formName = this.formState.manageState('formName');
        this.form = document.querySelector(this.formName);
        let validateForm = new ValidateFields(this.formState);
        let readyToSendForm = validateForm.validateSubmitForm(this.form, 'Contacto');
        let dataAVI = new loadDataAVI(this.formState);
        let isAVI = dataAVI.isAVI();
        if (isAVI) {
            readyToSendForm = true;
        }
        if (readyToSendForm) {
            // Get form data
            let userData = this.setUserForm(this.form);
            let contactData = this.setContactForm();
            let utmData = this.setUtmForm();
            let sendContact = true;
            setUserData(userData);
            let formData = { ...userData, ...contactData, ...utmData };
            this.setLQNData(formData);
            this.contextComponent = this.formState.manageState('contextComponent');
            this.loadSendForm(this.form);
            this.openCalculator = this.formState.manageState('openCalculator');
            if (this.form.querySelector('#btn-form')) {
                this.form.querySelector('#btn-form').disabled = true;
                (_b = this.form.querySelector('#btn-form .js-message')) === null || _b === void 0 ? void 0 : _b.classList.add("d-none");
                (_c = this.form.querySelector('#sending-mss')) === null || _c === void 0 ? void 0 : _c.classList.remove("d-none");
            }
            else if (this.form.querySelector('#btn-form-image')) {
                (_d = this.form.querySelector('#btn-form-image')) === null || _d === void 0 ? void 0 : _d.setAttribute("disabled", 'true');
                (_e = this.form.querySelector('#btn-form-image .js-message')) === null || _e === void 0 ? void 0 : _e.classList.add("d-none");
                (_f = this.form.querySelector('#sending-mss-image')) === null || _f === void 0 ? void 0 : _f.classList.remove("d-none");
            }
            if (this.openCalculator) {
                const sendFormCalculator = new CalculatorForm(this.formState);
                let calculatorData = sendFormCalculator.setCalculatorForm(this.form);
                this.UrlApi = '/api/v1/calculator';
                formData = { ...formData, ...calculatorData };
            }
            // change the sending to the preregistration log if the value of the income is less than the required value.
            if (formData.contextReference == 'pop-up-formulario') {
                const income = this.form.querySelector('#familyIncomeBanner');
                if (income === null || income === void 0 ? void 0 : income.value.includes('Inferior')) {
                    sendFormPreregistro.submitForm;
                    sendContact = false;
                }
            }
            if (sendContact) {
                this.loadSendForm(this.form);
                // Instantiate the service to send the form data
                const sendForm = new FormService(this.formState);
                sendForm.sendLead(this.UrlApi, formData);
            }
        }
    }
    loadSendForm(form) {
        var _a, _b;
        if (form.querySelector('.load-send-form')) {
            (_a = form.querySelector('.load-send-form')) === null || _a === void 0 ? void 0 : _a.classList.add('d-flex');
        }
        if (form.querySelector('#fields-form')) {
            (_b = form.querySelector('#fields-form')) === null || _b === void 0 ? void 0 : _b.classList.add('d-none');
        }
    }
    /**
     * Method to gather the form data.
     * @returns {UserInterface} An object of type UserInterface containing the form information.
     */
    setUserForm(form) {
        var _a, _b, _c, _d, _e, _f;
        this.countryCode = this.formState.manageState('countryCode');
        this.phone = (_a = form.querySelector('[name="phone"]')) === null || _a === void 0 ? void 0 : _a.value;
        let functions = new textFunctions;
        // Return an object with the extracted form data and context information
        return {
            name: functions.formatNameLastname((_b = form.querySelector('[name="name"]')) === null || _b === void 0 ? void 0 : _b.value),
            lastName: functions.formatNameLastname((_c = form.querySelector('[name="lastname"]')) === null || _c === void 0 ? void 0 : _c.value),
            mail: ((_d = form.querySelector('[name="email"]')) === null || _d === void 0 ? void 0 : _d.value) || ((_e = form.querySelector('[name="corporateEmail"]')) === null || _e === void 0 ? void 0 : _e.value),
            phone: this.countryCode + this.phone,
            countryCode: this.countryCode,
            habitar_invertir: Number((_f = form.querySelector('[name="habitar_invertir"]:checked')) === null || _f === void 0 ? void 0 : _f.value),
        };
    }
    setUtmForm() {
        let utm_source = this.formState.manageState('utm_source');
        let utm_medium = this.formState.manageState('utm_medium');
        let utm_campaign = this.formState.manageState('utm_campaign');
        let utm_content = this.formState.manageState('utm_content');
        return {
            utm_source: utm_source,
            utm_medium: utm_medium,
            utm_campaign: utm_campaign,
            utm_content: utm_content,
        };
    }
    /**
     * Method to gather the form data.
     * @returns {projectInterface} An object of type projectInterface containing the form information.
     */
    setContactForm() {
        var _a;
        // Define the context path based on the URL
        let contextPath = window.location.pathname.split('/')[1] + '/';
        let referrer = this.formState.manageState('referrer');
        let productOfert = this.formState.manageState('productOfert');
        let origen = new URLSearchParams(window.location.search).get('utm_campaign') === 'AVI' ? 'AVI' : this.formState.manageState('origen');
        let countryCode = this.formState.manageState('countryCode');
        let pdfUrl = '';
        let contact = sessionStorage.getItem('medio_contact');
        if (contact) {
            this.contact = Number(contact);
        }
        if ((_a = document.querySelector('body')) === null || _a === void 0 ? void 0 : _a.classList.contains('page-node-type-typology')) {
            contextPath = '/typology/';
            this.contextComponent = 'interna';
            const sendPDFLink = (document.querySelector("#typologyForm input[name='sendPDF']:checked"));
            const typology = new Typology(this.formState);
            if (sendPDFLink && sendPDFLink.value == 'send') {
                pdfUrl = typology.buildPDFLink(this.ID, this.UrlApi);
            }
        }
        if (productOfert == 8) {
            const whiteBrand = document.getElementById('titleWhiteBrand');
            const refererWhiteBrand = whiteBrand ? whiteBrand.getAttribute('data-title') : '';
            referrer = refererWhiteBrand ? refererWhiteBrand + ' - Ferias propias' : 'Ferias propias'; // Referrer White Brand
        }
        // Return an object with the extracted form data and context information
        return {
            contextDevice: getDeviceType(),
            contextOrigin: origen,
            contextComponent: this.contextComponent,
            contextEvent: "contactar",
            contextPath: contextPath,
            contextReference: referrer,
            medio_contact: this.contact,
            precio: this.typologyPrice,
            project_reference: this.ID,
            preferenceNode: this.ID,
            field_contact_product: productOfert,
            countryCode: countryCode,
            sendPDFLink: pdfUrl
        };
    }
    setLQNData(data) {
        var _a;
        let modal = document.getElementById('calculusModal');
        let submitModalBtn = document.getElementById('form-modal-results'); // Revisar funcionalidad
        let submitSpan = document.getElementById('value-form-submit'); // Revisar funcionalidad
        let interesRate = this.typologyType == '11660' || this.typologyType == '11801' ? '11.85' : '12.61';
        this.phone = this.countryCode == '+ 57' ? this.phone : '';
        (_a = document.getElementById('confirm-send-form-2-text')) === null || _a === void 0 ? void 0 : _a.classList.toggle('d-none', this.typologyProperty == 'Lote');
        modal === null || modal === void 0 ? void 0 : modal.setAttribute('data-house-price', this.typologyPrice);
        modal === null || modal === void 0 ? void 0 : modal.setAttribute('data-house-type', this.typologyType);
        modal === null || modal === void 0 ? void 0 : modal.setAttribute('data-node-name', this.typologyName);
        modal === null || modal === void 0 ? void 0 : modal.setAttribute('data-node-id', this.ID.toString());
        modal === null || modal === void 0 ? void 0 : modal.setAttribute('data-percentage', interesRate);
        modal === null || modal === void 0 ? void 0 : modal.setAttribute('data-income', this.typologyIncome || 'not');
        modal === null || modal === void 0 ? void 0 : modal.setAttribute('data-user-name', data.name);
        modal === null || modal === void 0 ? void 0 : modal.setAttribute('data-user-lastname', data.lastName);
        modal === null || modal === void 0 ? void 0 : modal.setAttribute('data-user-phone', data.phone);
        modal === null || modal === void 0 ? void 0 : modal.setAttribute('data-user-phone-lqn', this.phone);
        modal === null || modal === void 0 ? void 0 : modal.setAttribute('data-user-email', data.mail);
        modal === null || modal === void 0 ? void 0 : modal.setAttribute('data-user-destination', data.habitar_invertir.toString());
        submitModalBtn === null || submitModalBtn === void 0 ? void 0 : submitModalBtn.setAttribute('data-price', this.typologyPrice);
        submitModalBtn === null || submitModalBtn === void 0 ? void 0 : submitModalBtn.setAttribute('data-project-id', this.ID.toString());
        submitSpan === null || submitSpan === void 0 ? void 0 : submitSpan.setAttribute('data-price', this.typologyPrice);
        submitSpan === null || submitSpan === void 0 ? void 0 : submitSpan.setAttribute('data-project-id', this.ID.toString());
        let typologyTitle = Array.from(document.getElementsByClassName('calculusModalTypologyName'));
        typologyTitle.forEach(title => {
            title.textContent = this.typologyName;
        });
    }
}
// Exporting the class for use in other modules
export { ContactForm };
